import React from "react";
import { Modal, Button } from "react-bootstrap";
import Moment from "react-moment";
import { FormatNumber } from "../../../Component/FormatNumber/FormatNumber";

const ViewDetailsModal = ({ show, handleClose, selectedItem }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Franchise Withdrawal Details</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "auto" }}
      >
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-sm-4">
              <strong>Franchise Name:</strong>
            </div>
            <div className="col-sm-8 text-capitalize">
              {selectedItem?.franchise?.name ||
                selectedItem?.franchiseId?.name ||
                "-"}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4">
              <strong>Withdrawal Amount:</strong>
            </div>
            <div className="col-sm-8">
              {FormatNumber(selectedItem?.amount || 0)}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4">
              <strong>Available Balance:</strong>
            </div>
            <div className="col-sm-8">
              {FormatNumber(selectedItem?.availableBalance ?? 0)}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4">
              <strong>Request Date:</strong>
            </div>
            <div className="col-sm-8">
              <Moment format="YYYY/MM/DD HH:mm">
                {selectedItem?.createdAt}
              </Moment>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4">
              <strong>Status:</strong>
            </div>
            <div className="col-sm-8">
              {selectedItem?.status === "approved" ? (
                <span
                  className="bg-success px-2 py-1 text-white rounded-3"
                  style={{ fontSize: "12px" }}
                >
                  approved
                </span>
              ) : selectedItem?.status === "rejected" ? (
                <span
                  className="bg-danger px-2 py-1 text-white rounded-3"
                  style={{ fontSize: "12px" }}
                >
                  {selectedItem?.status}
                </span>
              ) : (
                <span
                  className="bg-warning px-2 py-1 text-white rounded-3"
                  style={{ fontSize: "12px" }}
                >
                  {selectedItem?.status}
                </span>
              )}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4">
              <strong>Notes:</strong>
            </div>
            <div
              className="col-sm-8"
              style={{
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #e0e0e0",
                padding: "10px",
                borderRadius: "4px",
                backgroundColor: "#f8f9fa",
              }}
            >
              {selectedItem?.notes ||
                selectedItem?.message ||
                "No notes available"}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewDetailsModal;
